import { render, staticRenderFns } from "./CapturaVoz.vue?vue&type=template&id=33f2643a&scoped=true"
import script from "./CapturaVoz.vue?vue&type=script&lang=js"
export * from "./CapturaVoz.vue?vue&type=script&lang=js"
import style0 from "./CapturaVoz.vue?vue&type=style&index=0&id=33f2643a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f2643a",
  null
  
)

export default component.exports